// Referral code persistence between landing page and signup form.
// Lives in sessionStorage so it survives in-tab navigation (LP → signin →
// signup) but auto-clears when the user closes the tab. We don't want a
// stale code persisting for weeks across browser sessions.
const KEY = "sytofood.ref";

export function readReferralCode(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const v = window.sessionStorage.getItem(KEY);
    if (!v) return null;
    const trimmed = v.trim().toUpperCase();
    return trimmed || null;
  } catch {
    return null;
  }
}

export function writeReferralCode(code: string | null): void {
  if (typeof window === "undefined") return;
  try {
    if (code) {
      window.sessionStorage.setItem(KEY, code.trim().toUpperCase());
    } else {
      window.sessionStorage.removeItem(KEY);
    }
  } catch {
    // sessionStorage blocked (Safari private mode etc): silently degrade,
    // user can paste the code manually on the signup form.
  }
}
